/**
 * agentChatTransport — Agent Chat 이 쓰는 백엔드 API 파사드.
 *
 * 패널이 `scenarioService` 를 직접 부르면, 이름만 봐도 "시나리오 화면 전용 서비스"처럼 읽히고
 * 챗이 실제로 무슨 엔드포인트에 의존하는지가 800줄이 넘는 서비스 파일에 묻힌다. 챗이 쓰는 6개만
 * 여기 모아 의존 표면을 명시한다.
 *
 * ⚠️ 주입 가능한 인터페이스로 만들지 않은 것은 의도다 — 챗 백엔드는 하나뿐이고,
 *   소비자가 1명인 추상화는 비용만 남는다. 백엔드가 갈라지면 그때 주입으로 승격할 것.
 *
 * modCode 는 백엔드 라우팅 키다(ScenarioAiV1Controller#dispatch). 화면 지식이 아니라
 *   "어느 모듈 에이전트에게 말하는가"라서 챗이 계속 들고 있는다.
 */
import scenarioService from "@plannel/services/ai/scenarioService";

const agentChatTransport = {
  /** 한 턴 — SSE 스트리밍(델타 + 도구 진행). onEvent 로 이벤트를 흘린다. */
  stream: (modCode, ctx, text, session, handlers) =>
    scenarioService.chatStream(modCode, ctx, text, session, handlers),

  /** 한 턴 — 비스트리밍 폴백. 반환 형태는 stream 의 최종 result 와 동일. */
  send: (modCode, ctx, text, session) =>
    scenarioService.chat(modCode, ctx, text, session),

  /**
   * 진행 중인 턴 취소 요청.
   *   ⚠️ SSE 를 끊는 것만으로는 LLM 이 멈추지 않는다(서버 측 격리). 이 요청이 유일한 중지 경로.
   */
  abort: (modCode, { sessionId }) =>
    scenarioService.chatAbort(modCode, { sessionId }),

  /** 세션 목록 — "all" 은 모듈 무관 전체(세션은 사용자 전역이다). */
  sessionList: (scope = "all") => scenarioService.chatSessionList(scope),

  /** 세션 대화 복원 */
  sessionMessages: (modCode, sessionId) => scenarioService.chatSessionMessages(modCode, sessionId),

  /** 세션 삭제 */
  sessionDelete: (modCode, sessionId) => scenarioService.chatSessionDelete(modCode, sessionId),

  /** 답변 피드백(좋아요/싫어요 + 사유) */
  feedback: (modCode, payload) => scenarioService.chatFeedback(modCode, payload),
};

export default agentChatTransport;
